"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eAdjustmentStatus = exports.eAdjustmentConcept = exports.eAdjustmentType = void 0;
const invoiceAdjustment_class_1 = __importDefault(require("./invoiceAdjustment.class"));
var eAdjustmentType;
(function (eAdjustmentType) {
    eAdjustmentType["DEBIT"] = "DEBIT";
    eAdjustmentType["CREDIT"] = "CREDIT";
})(eAdjustmentType = exports.eAdjustmentType || (exports.eAdjustmentType = {}));
var eAdjustmentConcept;
(function (eAdjustmentConcept) {
    eAdjustmentConcept["CANCELLED_CERTIFICATE"] = "Cancelled certificate";
    eAdjustmentConcept["DEDUCTIONS_PREV_MONTH"] = "Deductions previous month";
    eAdjustmentConcept["CHANGES_PREMIUM_VALUE"] = "Changes in premium value";
    eAdjustmentConcept["CHANGES_COMMISSION_VALUE"] = "Changes in commission value";
    eAdjustmentConcept["CHANGES_FEES"] = "Changes on fees";
    eAdjustmentConcept["CHANGES_TAXES"] = "Changes on taxes";
})(eAdjustmentConcept = exports.eAdjustmentConcept || (exports.eAdjustmentConcept = {}));
var eAdjustmentStatus;
(function (eAdjustmentStatus) {
    eAdjustmentStatus["PENDING_REVIEW"] = "PENDING_REVIEW";
    eAdjustmentStatus["APPROVED"] = "APPROVED";
    eAdjustmentStatus["REJECTED"] = "REJECTED";
    eAdjustmentStatus["APPLIED"] = "APPLIED";
})(eAdjustmentStatus = exports.eAdjustmentStatus || (exports.eAdjustmentStatus = {}));
exports.default = invoiceAdjustment_class_1.default;
//# sourceMappingURL=index.js.map